var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 2.9375H10.418L9.48828 1.40625C9.26953 1.02344 8.83203 0.75 8.36719 0.75H5.60547C5.14062 0.75 4.70312 1.02344 4.48438 1.40625L3.55469 2.9375H1.3125C1.06641 2.9375 0.875 3.15625 0.875 3.375V3.8125C0.875 4.05859 1.06641 4.25 1.3125 4.25H1.75L2.32422 13.5195C2.35156 14.2305 2.92578 14.75 3.63672 14.75H10.3359C11.0469 14.75 11.6211 14.2305 11.6484 13.5195L12.25 4.25H12.6875C12.9062 4.25 13.125 4.05859 13.125 3.8125V3.375C13.125 3.15625 12.9062 2.9375 12.6875 2.9375ZM5.60547 2.0625H8.36719L8.88672 2.9375H5.08594L5.60547 2.0625ZM10.3359 13.4375H3.63672L3.0625 4.25H10.9102L10.3359 13.4375Z",
    fill: "#959CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.33e92475.svg";
export { ForwardRef as ReactComponent };